export const CHECK_DOCUMENT = "authenticity/check"